<template>
    <div class="excel-wrapper">
        <div v-if="sheets.length > 1" class="sheet-tabs">
            <button v-for="sheet in sheets" :key="sheet" :class="{ active: sheet === currentSheet }"
                @click="selectSheet(sheet)">
                {{ sheet }}
            </button>
        </div>

        <div class="table-scroll">
            <table class="excel-table" v-if="tableData.length">
                <thead>
                    <tr>
                        <th v-for="(head, index) in tableData[0]" :key="index">{{ head }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, rIndex) in tableData.slice(1)" :key="rIndex">
                        <td v-for="(cell, cIndex) in row" :key="cIndex">{{ cell }}</td>
                    </tr>
                </tbody>
            </table>
            <p v-else>No data available</p>
        </div>
    </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
    name: "ExcelViewer",
    props: {
        fileUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            tableData: [],
            sheets: [],
            currentSheet: "",
            workbook: null,
        };
    },
    mounted() {
        this.loadExcel();
    },
    methods: {
        async loadExcel() {
            try {
                const res = await fetch(this.fileUrl);
                const blob = await res.blob();
                const arrayBuffer = await blob.arrayBuffer();
                this.workbook = XLSX.read(arrayBuffer, { type: "array" });
                this.sheets = this.workbook.SheetNames;
                this.currentSheet = this.sheets[0];
                this.renderSheet(this.currentSheet);
            } catch (err) {
                console.error("Error loading Excel file:", err);
            }
        },
        renderSheetBak(sheetName) {
            const worksheet = this.workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            this.tableData = json;
        },
        renderSheet(sheetName) {
            const worksheet = this.workbook.Sheets[sheetName];
            const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (!Array.isArray(rawData) || rawData.length === 0) {
                this.tableData = [];
                return;
            }

            // Find the row with the maximum number of columns
            const maxColumns = Math.max(...rawData.map(row => (Array.isArray(row) ? row.length : 0)));

            // Normalize all rows to have equal columns
            const normalizedData = rawData.map(row => {
                const newRow = Array.isArray(row) ? [...row] : [];
                while (newRow.length < maxColumns) {
                    newRow.push("");
                }
                return newRow;
            });
            console.log("normalizedData=>", normalizedData)

            this.tableData = normalizedData;
        },
        selectSheet(sheetName) {
            this.currentSheet = sheetName;
            this.renderSheet(sheetName);
        },
    },
};
</script>

<style scoped>
.excel-wrapper {
    font-family: 'Segoe UI', sans-serif;
}

.sheet-tabs {
    margin-bottom: 12px;
}

.sheet-tabs button {
    margin-right: 6px;
    padding: 6px 12px;
    border: 1px solid #ddd;
    background: #f4f4f4;
    cursor: pointer;
}

.sheet-tabs .active {
    background: #0078d7;
    color: white;
    border-color: #0078d7;
}

.table-scroll {
    overflow-x: auto;
}

.excel-table {
    border-collapse: collapse;
    width: 100%;
    min-width: 600px;
}

.excel-table th,
.excel-table td {
    border: 1px solid #ccc;
    padding: 6px 10px;
    text-align: left;
    background: #fff;
}

.excel-table th {
    background: #92df69;
}
</style>

<!-- components/ExcelViewer.vue
<template>
    <div>
        {{ viewerUrl }}
      <iframe
        v-if="viewerUrl"
        :src="viewerUrl"
        width="100%"
        height="700px"
        frameborder="0"
      ></iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: "ExcelViewer",
    props: {
      fileUrl: {
        type: String,
        required: true,
      },
    },
    computed: {
      viewerUrl() {
        const encoded = encodeURIComponent(this.fileUrl);
        return `https://view.officeapps.live.com/op/view.aspx?src=${this.fileUrl}`;
      },
    },
  };
  </script>
   -->


// WEBPACK FOOTER //
// ExcelViewer.vue?a690a9e6